import React, { useEffect } from "react";
import { motion, useReducedMotion } from "framer-motion";

/**
 * Scroll reveal wrapper. Uses framer-motion whileInView; renders statically
 * when the visitor prefers reduced motion. Content is NEVER hidden if motion
 * cannot run — the reveal is additive, not a gate.
 */
export function Reveal({ children, delay = 0, y = 28, className = "", as = "div" }) {
  const reduce = useReducedMotion();
  const Comp = motion[as] || motion.div;
  if (reduce) {
    const Static = as;
    return <Static className={className}>{children}</Static>;
  }
  return (
    <Comp
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.15 }}
      transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
    >
      {children}
    </Comp>
  );
}

/** Masked line-by-line reveal for display headlines (the signature on-load moment). */
export function MaskedLines({ lines, className = "", lineClassName = "", delay = 0 }) {
  const reduce = useReducedMotion();
  if (reduce) {
    return (
      <div className={className}>
        {lines.map((l, i) => (
          <div key={i} className={lineClassName}>
            {l}
          </div>
        ))}
      </div>
    );
  }
  return (
    <div className={className}>
      {lines.map((l, i) => (
        <div key={i} className="overflow-hidden">
          <motion.div
            className={lineClassName}
            initial={{ y: "110%" }}
            animate={{ y: 0 }}
            transition={{ duration: 0.9, delay: delay + i * 0.14, ease: [0.22, 1, 0.36, 1] }}
          >
            {l}
          </motion.div>
        </div>
      ))}
    </div>
  );
}
